import type { BusinessUnit } from '@backend/lib-l10n';

import { getJobsBusinessUnitUrl } from '~/config';
import { businessUnits } from '~/config/businessUnits';
import { getDefaultBusinessUnit, isEnabledBusinessUnit } from '~/utils/businessUnit';
import { getMissionUrl } from '~/utils/missionUrl';

export type HreflangLink = {
  hreflang: string;
  href: string;
};

// Alternates are the same site in other languages: FR and PM are two brands (and share `fr-FR`), not translations
// an iframe board is embedded in another site, which declares its own alternates
export const getRootHreflangLinks = (businessUnit: BusinessUnit): HreflangLink[] => {
  const { brandName, iframe } = businessUnits[businessUnit];
  if (iframe) {
    return [];
  }
  const alternates = Object.values(businessUnits).filter(
    alternate =>
      alternate.brandName === brandName && !alternate.iframe && isEnabledBusinessUnit(alternate.businessUnit),
  );
  const defaultBusinessUnit = getDefaultBusinessUnit();
  const xDefault = alternates.some(alternate => alternate.businessUnit === defaultBusinessUnit)
    ? defaultBusinessUnit
    : businessUnit;

  return [
    ...alternates.map(alternate => ({
      hreflang: alternate.locale,
      href: getJobsBusinessUnitUrl(alternate.businessUnit),
    })),
    { hreflang: 'x-default', href: getJobsBusinessUnitUrl(xDefault) },
  ];
};

export const getMissionHreflangLinks = (businessUnit: BusinessUnit, slug: string): HreflangLink[] =>
  businessUnits[businessUnit].iframe
    ? []
    : [{ hreflang: businessUnits[businessUnit].locale, href: getMissionUrl(businessUnit, slug) }];
